module.exports = __webpack_public_path__ + "media/images/LOGO-3fd53f9212b1fd83a429449b16e070aa.png";